<template>
   <div class='form-wrapper' :class="{'broad-width': broadWidth}">
      <slot></slot>
   </div>
</template>

<script>
export default {
   name: 'form-wrapper',
   props: {
      broadWidth: {
         type: Boolean,
         default: false,
      }
   }
}
</script>

<style lang="scss" scoped>
.form-wrapper
{
   width: 50%;
   max-width: 320px;
   margin-bottom: 1vh;
   
   &.broad-width {
      max-width: none;
      width: auto;
      margin-left: 5%;
      margin-right: 5%;
      // margin-bottom: 35vh;
   }

   @media screen and (max-width: 700px)
   {
      width: 60%;
   }
   @media screen and (max-width: 450px)
   {
      width: 80%;
   }
}
</style>